<script lang="ts">
    const currentYear = new Date().getFullYear();
</script>

<footer class="w-full bg-[#212121] border-t border-white/10">
    <div class="container mx-auto px-4 md:px-8 max-w-7xl py-12">
        <div class="flex flex-wrap gap-y-8">
            <!-- Contact -->
            <div class="w-full md:w-auto md:flex-1 flex flex-col items-start">
                <h3 class="text-sm font-medium text-white/80 mb-3">Contact</h3>
                <a href="mailto:mail@jonasloh.com" 
                   class="text-sm text-white/60 hover:text-[#F96604] transition-colors inline-flex items-center gap-2">
                    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    mail@jonasloh.com
                </a>
            </div>
            
            <!-- Social -->
            <div class="w-full md:w-auto md:flex-1 flex flex-col items-start">
                <h3 class="text-sm font-medium text-white/80 mb-3">Social</h3>
                <div class="flex gap-4">
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" 
                       class="text-white/60 hover:text-[#F96604] transition-colors">
                        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                        </svg>
                    </a>
                    <a href="https://www.instagram.com/jonas_loh/?hl=en" target="_blank" rel="noopener noreferrer"
                       class="text-white/60 hover:text-[#F96604] transition-colors">
                        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/>
                        </svg>
                    </a>
                </div>
            </div>
            
            <!-- Legal -->
            <div class="w-full md:w-auto md:flex-1 flex flex-col items-start">
                <h3 class="text-sm font-medium text-white/80 mb-3">Legal</h3>
                <div class="flex gap-4">
                    <a href="/imprint" class="text-sm text-white/60 hover:text-[#F96604] transition-colors">Imprint</a>
                </div>
            </div>
        </div>
        
        <!-- Copyright -->
        <div class="mt-8 pt-8 border-t border-white/10">
            <p class="text-sm text-white/40">
                © {currentYear} Jonas Loh. All rights reserved.
            </p>
        </div>
    </div>
</footer> 